var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.406251 5.28125L5.40625 0.281249C5.59375 0.0937493 5.84375 -7.21238e-07 6.09375 -6.99382e-07C6.375 -6.74795e-07 6.625 0.0937493 6.8125 0.281249C7.21875 0.656249 7.21875 1.3125 6.8125 1.6875L3.53125 5L13.0938 5C13.6563 5 14.0938 5.4375 14.0938 6C14.0938 6.53125 13.6563 7 13.0938 7L3.53125 7L6.8125 10.2812C7.21875 10.6562 7.21875 11.3125 6.8125 11.6875C6.4375 12.0937 5.78125 12.0937 5.40625 11.6875L0.406251 6.6875C6.72063e-07 6.3125 7.29434e-07 5.65625 0.406251 5.28125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.661e1821b1eb417bb73803c7fc67f712.svg";
export { ForwardRef as ReactComponent };